<template>
  <PageContainer id="top-rated-page">
    <div class="page-content">
      <div class="title">If you have any doubts, do some research on our outstanding reputation:</div>
      <img class="mainImg_v2" :src="appsImg" alt="Top rated mobile apps logos">
      <div class="title small">As seen on:</div>
      <div class="images">
        <img :src="todayImg" alt="Top rated logos">
        <img :src="gmaImg" alt="Top rated logos">
        <img :src="cnnImg" alt="Top rated logos">
      </div>
    </div>

    <div class="footer-container">
      <ButtonNext :onClick="next" :isDisabled="false" :text="'Next'" />
      <ProgressBar />
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '../../shared/components/PageContainer';
import ButtonNext from '../../shared/components/ButtonNext';
import ProgressBar from '../../shared/components/ProgressBar';
import Trackeable from '../../Trackeable';
import Globalized from '../../shared/components/Globalized';
import { STATIC_URL } from '../main';
import ProgressFull from '../mixins/ProgressFull';
import { delayedTransition, ROUTE_NAMES } from '../router';

const PAID_OUT_AMOUNT = 9217664.43;

export default {
  components: {
    PageContainer,
    ButtonNext,
    ProgressBar
  },
  mixins: [Trackeable, Globalized, ProgressFull],
  data: function() {
    return {
      paidOutValue: `${this.site().fullMoneyString(PAID_OUT_AMOUNT)}`,
      appsImg: `${STATIC_URL}img/spa/apps_image_v2.png`,
      todayImg: `${STATIC_URL}img/funnel-v4/today.png`,
      gmaImg: `${STATIC_URL}img/funnel-v4/gma.png`,
      cnnImg: `${STATIC_URL}img/press-logos/cnn-logo.png`
    }
  },
  methods: {
    next() {
      delayedTransition(this.$router, ROUTE_NAMES.Calculating)
    }
  }
}
</script>
